/* VR SHOP · Refresh nov-2026
   1) Indicador de fotos en la galería móvil de la ficha.
   2) Barra fija de compra en móvil (precio + botón) cuando el botón principal no está a la vista.
   3) Confirmación de talla: evita comprar la talla que viene marcada por defecto sin haberla elegido. */
(() => {
  'use strict';
  const isProduct = document.body.classList.contains('template-product');
  if (!isProduct) return;
  const section = document.querySelector('#MainContent .section-main-product') || document.querySelector('.section-main-product');
  if (!section) return;
  const mobile = window.matchMedia('(max-width: 768px)');

  /* ---------- 1. Galería: puntos + contador ---------- */
  function setupGallery() {
    const slider = section.querySelector('product-media .product-gallery-slider');
    if (!slider) return;
    let tries = 0;
    const wait = () => {
      const sw = slider.swiper;
      if (!sw) { if (tries++ < 40) setTimeout(wait, 150); return; }
      const holder = slider;
      // Marco de la foto según la primera imagen (entre 3:5 y 4:5): la prenda se ve completa y sin franjas grandes.
      const first = Array.from(slider.querySelectorAll('.swiper-slide img')).find((im) => im.offsetParent !== null) || slider.querySelector('.swiper-slide img');
      const setRatio = () => {
        const w = first && (first.naturalWidth || +first.getAttribute('width'));
        const h = first && (first.naturalHeight || +first.getAttribute('height'));
        if (w && h) { const r = Math.min(0.8, Math.max(0.6, w / h)); section.querySelector('product-media').style.setProperty('--vrx-ratio', r.toFixed(3)); try { sw.update(); } catch (e) {} }
      };
      if (first) { if (first.complete) setRatio(); else first.addEventListener('load', setRatio, { once: true }); }
      holder.style.position = holder.style.position || 'relative';
      let dots = holder.querySelector('.vrx-gallery-ui');
      let count = holder.querySelector('.vrx-gallery-count');
      if (!dots) { dots = document.createElement('div'); dots.className = 'vrx-gallery-ui'; dots.setAttribute('aria-hidden', 'true'); holder.appendChild(dots); }
      if (!count) { count = document.createElement('span'); count.className = 'vrx-gallery-count'; count.setAttribute('aria-hidden', 'true'); holder.appendChild(count); }
      const visibleSlides = () => Array.from(sw.slides || []).filter((s) => s.offsetParent !== null && getComputedStyle(s).display !== 'none');
      const render = () => {
        const slides = visibleSlides();
        const n = slides.length;
        if (n < 2) { dots.innerHTML = ''; count.textContent = ''; count.style.display = 'none'; return; }
        count.style.display = '';
        const activeEl = sw.slides[sw.activeIndex];
        let idx = Math.max(0, slides.indexOf(activeEl));
        if (dots.childElementCount !== n) dots.innerHTML = '<i></i>'.repeat(n);
        Array.from(dots.children).forEach((d, i) => d.classList.toggle('is-on', i === idx));
        count.textContent = `${idx + 1} / ${n}`;
      };
      sw.on('slideChange', render);
      sw.on('update', render);
      render();
      section.addEventListener('change', () => setTimeout(render, 350));
    };
    wait();
  }

  /* ---------- 2 y 3. Talla y barra fija ---------- */
  const form = section.querySelector('product-form form, form.main-product-form');
  const addBtn = section.querySelector('button[name="add"]');
  const fieldsets = Array.from(section.querySelectorAll('variant-selector fieldset'));
  const sizeField = fieldsets.find((f) => !f.classList.contains('color-swatches-box') && /talla|size/i.test(f.textContent)) || fieldsets.find((f) => !f.classList.contains('color-swatches-box'));
  const sizeInputs = sizeField ? Array.from(sizeField.querySelectorAll('input[type="radio"]')) : [];
  let sizeChosen = !sizeField || sizeInputs.length <= 1;
  const markChosen = () => { if (sizeField) { sizeField.classList.add('vrx-size-chosen'); sizeField.closest('variant-selector')?.classList.remove('vrx-size-pulse'); } };
  if (sizeField) { sizeField.classList.add('vrx-size-field'); if (sizeChosen) markChosen(); }

  if (sizeField && !sizeChosen) {
    const hint = document.createElement('p');
    hint.className = 'vrx-size-hint';
    hint.setAttribute('role', 'alert');
    hint.textContent = 'Elige tu talla para continuar.';
    sizeField.appendChild(hint);
    sizeField.addEventListener('click', (e) => {
      if (e.target.closest('label, input')) { sizeChosen = true; markChosen(); updateBar(); }
    });
    sizeField.addEventListener('change', () => { sizeChosen = true; markChosen(); updateBar(); });
  }

  function askSize() {
    const vs = sizeField.closest('variant-selector') || sizeField;
    vs.classList.remove('vrx-size-pulse');
    void vs.offsetWidth;
    vs.classList.add('vrx-size-pulse');
    sizeField.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // El botón principal pide la talla si aún no se ha elegido.
  if (addBtn && sizeField) {
    addBtn.addEventListener('click', (e) => {
      if (!sizeChosen) { e.preventDefault(); e.stopImmediatePropagation(); askSize(); }
    }, true);
    if (form) form.addEventListener('submit', (e) => {
      if (!sizeChosen) { e.preventDefault(); e.stopImmediatePropagation(); askSize(); }
    }, true);
  }

  // Barra fija (solo móvil)
  let bar, barBtn, barPrice, visible = false;
  function priceText() {
    const p = section.querySelector('.product-price-wrapper .product-actual-price');
    return p ? p.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function updateBar() {
    if (!bar) return;
    barPrice.textContent = priceText();
    const soldOut = addBtn && (addBtn.disabled || addBtn.hasAttribute('disabled'));
    barBtn.disabled = !!soldOut;
    barBtn.textContent = soldOut ? 'Agotado' : (sizeChosen ? 'Añadir al carrito' : 'Elegir talla');
  }
  function buildBar() {
    if (bar || !addBtn) return;
    const title = (section.querySelector('h1')?.textContent || '').trim();
    bar = document.createElement('div');
    bar.className = 'vrx-buybar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="vrx-buybar__info"><span class="vrx-buybar__name"></span><span class="vrx-buybar__price"></span></div><button type="button" class="vrx-buybar__btn" tabindex="-1"></button>';
    bar.querySelector('.vrx-buybar__name').textContent = title;
    barPrice = bar.querySelector('.vrx-buybar__price');
    barBtn = bar.querySelector('.vrx-buybar__btn');
    barBtn.addEventListener('click', () => {
      if (!sizeChosen && sizeField) { askSize(); return; }
      addBtn.click();
    });
    document.body.appendChild(bar);
    updateBar();
    const io = new IntersectionObserver((entries) => {
      const e = entries[0];
      const show = mobile.matches && !e.isIntersecting;
      if (show !== visible) {
        visible = show;
        bar.classList.toggle('is-visible', show);
        document.body.classList.toggle('vrx-buybar-on', show);
      }
    }, { threshold: 0 });
    io.observe(addBtn);
    // Mantener precio/estado al cambiar de variante
    const priceBox = section.querySelector('.product-price-wrapper');
    if (priceBox) new MutationObserver(() => updateBar()).observe(priceBox, { childList: true, subtree: true, characterData: true });
    new MutationObserver(() => updateBar()).observe(addBtn, { attributes: true, attributeFilter: ['disabled'] });
    // Ocultar mientras el carrito o un diálogo están abiertos
    document.addEventListener('click', () => setTimeout(() => {
      const busy = document.querySelector('cart-drawer.active, .cart-drawer.active, .drawer.active');
      bar.style.visibility = busy ? 'hidden' : '';
    }, 400));
  }

  const start = () => { setupGallery(); buildBar(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
